<template>
  <div class="j-container about-us-container">
    <div v-if="aboutus">
      <div class="j-title title">{{ aboutus.title }}</div>

      <div class="j-sub-title about-us-desc">
        {{ aboutus.summary }}
      </div>
    </div>

    <div
      v-if="selfLoaded && !aboutus"
      style="margin-bottom: 50px"
      class="j-coming-soon j-content"
    >
      {{ $t('common.coming_soon') }}
    </div>

    <div class="card-container">
      <a-row :gutter="[20, 20]" v-if="articles.length > 0">
        <a-col
          :xs="24"
          :sm="24"
          :md="8"
          v-for="(a, index) in articles"
          :key="a.id"
        >
          <div class="card" @click="gotoAboutUs">
            <ProfileIcon v-if="index === 0" class="icon" />
            <NetworkIcon v-if="index === 1" class="icon" />
            <HistoryIcon v-if="index === 2" class="icon" />

            <div class="content">
              <div class="content-title">{{ a.title }}</div>

              <div class="content-desc j-content about-us-content">
                <!-- {{ getSummary(a.summary) }} -->
                {{ a.summary }}
              </div>
            </div>
          </div>
        </a-col>
      </a-row>

      <div
        v-if="loaded && articles.length === 0"
        class="j-coming-soon j-content"
      >
        {{ $t('common.coming_soon') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
// import VClamp from 'vue-clamp';
import { mapState } from 'vuex';
import HistoryIcon from '@/components/icons/HistoryIcon.vue';
import NetworkIcon from '@/components/icons/NetworkIcon.vue';
import ProfileIcon from '@/components/icons/ProfileIcon.vue';
import { getArticleListByTypes } from '@/api/apis';
declare const $clamp: any;

export default defineComponent({
  name: 'AboutUsSection',
  components: {
    HistoryIcon,
    NetworkIcon,
    ProfileIcon
    // VClamp
  },
  props: {
    articles: {
      type: Array,
      required: true,
      default: () => []
    },
    loaded: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  watch: {
    lang() {
      this.loadData();
    }
  },
  data() {
    return {
      aboutus: null,
      selfLoaded: false
    };
  },
  created() {
    this.loadData();
  },
  updated() {
    const all = Array.from(this.$el.querySelectorAll('.about-us-content'));
    all.forEach(a => {
      $clamp(a, { clamp: 3 });
    });
  },
  methods: {
    // getSummary(summary) {
    //   return $clamp(summary, { clamp: 'auto' });
    // },
    gotoAboutUs() {
      this.$router.push('/about-us');
    },
    async loadData() {
      const res = await getArticleListByTypes({
        types: 4
      });

      if (res.success) {
        const arr = res.result || [];
        this.aboutus = arr[0];
      }

      this.selfLoaded = true;
    }
  }
});
</script>

<style lang="scss" scoped>
.title {
  text-align: center;
  margin-bottom: 30px;
}

.about-us-container {
  margin-bottom: 80px;

  .about-us-desc {
    max-width: 790px;
    margin: 0 auto;
    text-align: center;
    margin-bottom: 50px;
  }

  .card-container {
    .card {
      cursor: pointer;
      height: 180px;
      padding: 40px 40px 20px 40px;
      border: 1px solid $secondary-color2;
      border-radius: 8px;
      display: flex;

      &:hover {
        box-shadow: 0 5px 20px 0 #dddddd;
        transition: all 0.5s;
      }

      .icon {
        font-size: 50px;
        margin-right: 30px;
        display: flex;
        align-items: center;
      }

      .content {
        flex: 1;
        overflow: hidden;

        .content-title {
          font-size: 22px;
          margin-bottom: 14px;
          font-weight: bold;
        }

        .content-desc {
          /* display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical; */
          color: $primary-secondary-forecolor;
        }
      }
    }
  }
}
</style>
